document.addEventListener("DOMContentLoaded", () => {
  const get = (id) => document.getElementById(id);
  const getAll = (selector) => document.querySelectorAll(selector);
  const body = document.body;

  const searchContainer = get("search-container");
  const searchInput = get("search-input");
  const searchClose = get("search-close");
  const searchTriggers = getAll(".search-trigger-btn");

  const mobileMenu = get("mobile-menu");
  const menuOpen = get("menu-open");
  const menuClose = get("menu-close");
  const mobileDisclosures = document.querySelectorAll(".mobile-submenu-disclosure, .mobile-footer-disclosure");

  const menuLinks = document.querySelectorAll(".nav-link[data-link-index]");
  const megaMenus = document.querySelectorAll(".custom-header__mega-menu-wrapper");
  const header = document.querySelector(".rfrm-header");
  const desktopCountryContainer = document.querySelector(".country-container.desktop-only");

  let megaMenuCloseTimer = null;
  let activeMenu = null;
  let activeMenuLink = null;

  const syncBodyScroll = () => {
    const shouldLock = searchContainer?.classList.contains("active") || mobileMenu?.classList.contains("active");
    body.style.overflow = shouldLock ? "hidden" : "";
  };

  const closeCountryMenus = () => {
    document.querySelectorAll(".country-list.active").forEach((menu) => {
      menu.classList.remove("active");
    });

    ["country-trigger", "mobile-country-trigger"].forEach((id) => {
      const trigger = get(id);
      trigger?.classList.remove("active");
      trigger?.setAttribute("aria-expanded", "false");
    });
  };

  const clearMegaMenuCloseTimer = () => {
    if (!megaMenuCloseTimer) return;
    window.clearTimeout(megaMenuCloseTimer);
    megaMenuCloseTimer = null;
  };

  const clearMegaMenus = () => {
    clearMegaMenuCloseTimer();
    megaMenus.forEach((menu) => menu.classList.remove("show"));
    menuLinks.forEach((link) => link.classList.remove("active"));
    activeMenu = null;
    activeMenuLink = null;
  };

  const setActiveMegaMenu = (link) => {
    const targetMenu = document.querySelector(
      `.custom-header__mega-menu-wrapper[data-menu-index="${link.dataset.linkIndex}"]`
    );

    clearMegaMenuCloseTimer();

    if (!targetMenu) {
      clearMegaMenus();
      return;
    }

    megaMenus.forEach((menu) => menu.classList.remove("show"));
    menuLinks.forEach((item) => item.classList.remove("active"));

    targetMenu.classList.add("show");
    link.classList.add("active");
    activeMenu = targetMenu;
    activeMenuLink = link;
  };

  const scheduleMegaMenuClose = () => {
    clearMegaMenuCloseTimer();
    megaMenuCloseTimer = window.setTimeout(() => {
      const hoveringLink = Array.from(menuLinks).some((item) => item.matches(":hover"));
      const hoveringMenu = Array.from(megaMenus).some((menu) => menu.matches(":hover"));

      if (!hoveringLink && !hoveringMenu) {
        clearMegaMenus();
      }
    }, 120);
  };

  const closeSearch = () => {
    searchContainer?.classList.remove("active");
    searchContainer?.setAttribute("aria-hidden", "true");
    syncBodyScroll();
  };

  const closeMobileDisclosures = () => {
    mobileDisclosures.forEach((item) => {
      item.removeAttribute("open");
    });
  };

  const openSearch = (event) => {
    event?.preventDefault();
    mobileMenu?.classList.remove("active");
    mobileMenu?.setAttribute("aria-hidden", "true");
    searchContainer?.classList.add("active");
    searchContainer?.setAttribute("aria-hidden", "false");
    syncBodyScroll();

    window.setTimeout(() => searchInput?.focus(), 300);
  };

  const closeMobileMenu = () => {
    mobileMenu?.classList.remove("active");
    mobileMenu?.setAttribute("aria-hidden", "true");
    closeMobileDisclosures();
    syncBodyScroll();
  };

  const openMobileMenu = (event) => {
    event?.preventDefault();
    closeSearch();
    closeMobileDisclosures();
    mobileMenu?.classList.add("active");
    mobileMenu?.setAttribute("aria-hidden", "false");
    syncBodyScroll();
  };

  searchTriggers.forEach((btn) => {
    btn.addEventListener("click", openSearch);
  });

  searchClose?.addEventListener("click", closeSearch);
  menuOpen?.addEventListener("click", openMobileMenu);
  menuClose?.addEventListener("click", closeMobileMenu);

  const initCountrySelector = (triggerId, menuId) => {
    const trigger = get(triggerId);
    const menu = get(menuId);

    if (!trigger || !menu) return;

    trigger.addEventListener("click", (event) => {
      event.stopPropagation();

      const isActive = menu.classList.contains("active");
      closeCountryMenus();

      if (!isActive) {
        menu.classList.add("active");
        trigger.classList.add("active");
      }

      trigger.setAttribute("aria-expanded", String(!isActive));
    });

    menu.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => {
        const countryCode = link.dataset.rel;

        getAll("[data-current-market-short]").forEach((label) => {
          label.textContent = countryCode;
        });

        menu.classList.remove("active");
        trigger.classList.remove("active");
        trigger.setAttribute("aria-expanded", "false");
      });
    });
  };

  initCountrySelector("country-trigger", "country-menu");

  document.addEventListener("click", (event) => {
    if (searchContainer?.classList.contains("active") && event.target === searchContainer) {
      closeSearch();
    }

    if (
      mobileMenu?.classList.contains("active") &&
      !mobileMenu.contains(event.target) &&
      !menuOpen?.contains(event.target)
    ) {
      closeMobileMenu();
    }

    if (header && !header.contains(event.target)) {
      clearMegaMenus();
    }

    closeCountryMenus();
  });

  window.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;

    closeSearch();
    closeMobileMenu();
    closeCountryMenus();
    clearMegaMenus();
  });

  menuLinks.forEach((link) => {
    link.addEventListener("mouseenter", () => {
      closeCountryMenus();
      setActiveMegaMenu(link);
    });

    link.addEventListener("mouseleave", () => {
      scheduleMegaMenuClose();
    });
  });

  megaMenus.forEach((menu) => {
    menu.addEventListener("mouseenter", () => {
      clearMegaMenuCloseTimer();
      const linkedItem = document.querySelector(`.nav-link[data-link-index="${menu.dataset.menuIndex}"]`);
      if (linkedItem) {
        setActiveMegaMenu(linkedItem);
      } else {
        activeMenu = menu;
        menu.classList.add("show");
      }
    });

    menu.addEventListener("mouseleave", () => {
      scheduleMegaMenuClose();
    });
  });

  desktopCountryContainer?.addEventListener("mouseenter", () => {
    const trigger = get("country-trigger");
    const menu = get("country-menu");
    if (!trigger || !menu) return;
    clearMegaMenuCloseTimer();
    clearMegaMenus();
    closeCountryMenus();
    menu.classList.add("active");
    trigger.classList.add("active");
    trigger.setAttribute("aria-expanded", "true");
  });

  desktopCountryContainer?.addEventListener("mouseleave", () => {
    closeCountryMenus();
  });
});
